import apiClient from "../api/apiClient";
import { CONCERT_API } from "../api/consts";
import { TicketMessageAction, TicketMessageChannel } from "../pages/concertTickets/TicketMessageDialog";

export const getConcertTicketsByEventPaged = async (eventId: number, page: number, pageSize: number, search: string, sendStatus: string[], missingOnly: boolean) => {
  try {
    const res: any = await apiClient.post(`${CONCERT_API}/getConcertTicketsByEventPaged`, { eventId, page, pageSize, search, sendStatus, missingOnly });
    return res.data.data;
  } catch (error: any) {
    console.log("getConcertTicketsByEventPaged error", error);
    return Promise.reject(error);
  }
};

export const getConcertTicketsByEvaXML = async (eventId: number, page: number, pageSize: number, search: string, sendStatus: string[], missingOnly: boolean) => {
  try {
    const res: any = await apiClient.post(`${CONCERT_API}/getConcertTicketsByEvaXML`, { eventId, page, pageSize, search, sendStatus, missingOnly });
    return res.data.data;
  } catch (error: any) {
    console.log("getConcertTicketsByEvaXML error", error);
    return Promise.reject(error);
  }
};

export const getAllConcertEvents = async (from?: string, to?: string) => {
  try {
    const res: any = await apiClient.post(`${CONCERT_API}/getAllConcertEvents`, { from, to });
    return res.data.data;
  } catch (error: any) {
    console.log("getAllConcertEvents error", error);
		return Promise.reject(error);
  }
};

export const updateCostumersData = async (patches: any[]) => {
  try {
    const res: any = await apiClient.post(`${CONCERT_API}/updateCostumersData`, { patches });
    return res.data.data;
  } catch (error: any) {
    console.log("updateCostumersData error", error);
    return Promise.reject(error);
  }
};

export const sendInforUByChannelAndActionBulk = async (barcodes: string[], channel: TicketMessageChannel, action: TicketMessageAction) => {
  try {
    const res: any = await apiClient.post(`${CONCERT_API}/sendInforUByChannelAndActionBulk`, { barcodes, channel, action });
    return res.data.data;
  } catch (error: any) {
    console.log("sendInforUByChannelAndActionBulk error", error);
    return Promise.reject(error);
  }
};